

function lockUserInput() {
    buttonForSame = document.getElementById("same");
    buttonForDifferent = document.getElementById("different");

    buttonForSame.disabled = true;
    buttonForDifferent.disabled = true;

    buttonForSame.classList.add("disabled");
    buttonForDifferent.classList.add("disabled");
}

function unlockUserInput() {
    buttonForSame = document.getElementById("same");
    buttonForDifferent = document.getElementById("different");
    buttonForSame.disabled = false;
    buttonForDifferent.disabled = false;

    buttonForSame.classList.remove("disabled");
    buttonForDifferent.classList.remove("disabled");
}


function userInputSame() {
	givenUserInput = "same";
	console.log("++ ✍️ user input:", givenUserInput);
	lockUserInput();
    evaluateUserAnswer(expectedUserInput, givenUserInput);

}

function userInputDifferent() {
	givenUserInput = "different";
	console.log("++ ✍️ user input:", givenUserInput);
	lockUserInput();
    evaluateUserAnswer(expectedUserInput, givenUserInput);
}


function resetUserInput() {
    givenUserInput = "";
}


